// extracted by mini-css-extract-plugin
module.exports = {"SectionContainer":"Frontpage_SectionContainer__TKRZT","FullBleed":"Frontpage_FullBleed__pdgIK"};